<template>
  <svg
    width="70"
    height="61"
    viewBox="0 0 70 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(clip-icon-balloon-present-box-100px0)">
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M11.1128 11.6324H10.8379V13.1896H11.1128V11.6324Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M11.7539 12.5484V12.2736H10.1959V12.5484H11.7539Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M20.8863 45.5227H20.6113V47.0799H20.8863V45.5227Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M21.5273 46.4386V46.1638H19.9693V46.4386H21.5273Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M7.20464 27.4354H6.92969V28.9926H7.20464V27.4354Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M7.8457 28.3513V28.0765H6.28766V28.3513H7.8457Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M55.3414 0.944946H55.0664V2.50213H55.3414V0.944946Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M55.9824 1.86086V1.58606H54.4244V1.86086H55.9824Z"
          fill="#47E6B1"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M8.94878 4.81824H8.67383V6.37542H8.94878V4.81824Z"
          fill="#47E6B1"
        />
        <path
          opacity="0.5"
          d="M9.58984 5.73415V5.45935H8.0318V5.73415H9.58984Z"
          fill="#47E6B1"
        />
      </g>
      <path
        opacity="0.5"
        d="M14.2156 39.9657C14.1399 39.9327 14.079 39.873 14.0444 39.798C14.0098 39.7229 14.0041 39.6379 14.0282 39.5589C14.0321 39.5468 14.0346 39.5344 14.0356 39.5217V39.5217C14.0412 39.4843 14.0337 39.4461 14.0144 39.4135C13.9951 39.3809 13.9652 39.356 13.9297 39.3428C13.8941 39.3296 13.8552 39.3291 13.8193 39.3412C13.7834 39.3534 13.7528 39.3775 13.7326 39.4095V39.4095C13.725 39.4197 13.7186 39.4308 13.7136 39.4425C13.6806 39.5182 13.6208 39.5791 13.5458 39.6136C13.4707 39.6482 13.3856 39.6539 13.3066 39.6298C13.2945 39.626 13.282 39.6235 13.2694 39.6224V39.6224C13.2319 39.6169 13.1937 39.6244 13.1611 39.6437C13.1285 39.6629 13.1035 39.6928 13.0904 39.7283C13.0772 39.7638 13.0767 39.8028 13.0888 39.8386C13.101 39.8745 13.1251 39.9051 13.1571 39.9253V39.9253C13.1673 39.9329 13.1784 39.9392 13.1901 39.9443C13.2659 39.9773 13.3268 40.037 13.3614 40.112C13.3959 40.187 13.4017 40.2721 13.3776 40.3511C13.3737 40.3631 13.3712 40.3756 13.3701 40.3882V40.3882C13.3646 40.4257 13.3721 40.4639 13.3914 40.4965C13.4107 40.529 13.4406 40.554 13.4761 40.5672C13.5116 40.5803 13.5506 40.5809 13.5865 40.5687C13.6223 40.5566 13.6529 40.5325 13.6732 40.5004C13.6807 40.4902 13.6871 40.4791 13.6921 40.4674C13.7252 40.3918 13.7849 40.3309 13.86 40.2963C13.935 40.2618 14.0202 40.256 14.0992 40.2801C14.1113 40.284 14.1237 40.2865 14.1364 40.2875C14.1738 40.2931 14.2121 40.2856 14.2447 40.2663C14.2773 40.247 14.3022 40.2171 14.3154 40.1816C14.3286 40.1461 14.3291 40.1072 14.317 40.0713C14.3048 40.0355 14.2807 40.0049 14.2486 39.9847V39.9847C14.2384 39.9771 14.2273 39.9707 14.2156 39.9657Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M12.8535 54.7661C12.7777 54.7331 12.7168 54.6734 12.6823 54.5984C12.6477 54.5234 12.6419 54.4383 12.666 54.3593C12.6699 54.3472 12.6724 54.3348 12.6735 54.3222V54.3222C12.679 54.2847 12.6715 54.2465 12.6522 54.2139C12.6329 54.1813 12.603 54.1564 12.5675 54.1432C12.532 54.1301 12.493 54.1295 12.4571 54.1417C12.4213 54.1538 12.3907 54.1779 12.3704 54.2099C12.3629 54.2202 12.3565 54.2312 12.3515 54.2429C12.3186 54.3186 12.259 54.3795 12.1841 54.4142C12.1093 54.4489 12.0242 54.4549 11.9452 54.4311C11.9332 54.4272 11.9207 54.4247 11.9081 54.4237V54.4237C11.8706 54.4181 11.8324 54.4256 11.7998 54.4449C11.7672 54.4642 11.7422 54.4941 11.729 54.5296C11.7159 54.5651 11.7153 54.604 11.7275 54.6399C11.7396 54.6757 11.7637 54.7063 11.7958 54.7265V54.7265C11.806 54.7341 11.8171 54.7404 11.8288 54.7455C11.9045 54.7785 11.9655 54.8382 12 54.9132C12.0346 54.9882 12.0403 55.0733 12.0162 55.1523C12.0123 55.1644 12.0098 55.1768 12.0088 55.1894C12.0033 55.2269 12.0108 55.2651 12.0301 55.2977C12.0493 55.3303 12.0793 55.3552 12.1148 55.3684C12.1503 55.3815 12.1893 55.3821 12.2251 55.3699C12.261 55.3578 12.2916 55.3337 12.3118 55.3017V55.3017C12.3194 55.2914 12.3258 55.2804 12.3308 55.2687C12.3639 55.193 12.4236 55.1321 12.4987 55.0975C12.5737 55.063 12.6588 55.0572 12.7379 55.0813C12.7499 55.0852 12.7624 55.0877 12.775 55.0888C12.8125 55.0943 12.8507 55.0868 12.8833 55.0675C12.9159 55.0483 12.9409 55.0184 12.9541 54.9829C12.9672 54.9474 12.9678 54.9084 12.9556 54.8726C12.9435 54.8367 12.9194 54.8061 12.8873 54.7859V54.7859C12.8769 54.778 12.8655 54.7713 12.8535 54.7661V54.7661Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M62.9726 22.0043C62.8969 21.9712 62.8359 21.9115 62.8014 21.8365C62.7668 21.7615 62.7611 21.6764 62.7852 21.5974C62.7891 21.5854 62.7916 21.5729 62.7926 21.5603C62.7982 21.5229 62.7907 21.4846 62.7714 21.4521C62.7521 21.4195 62.7222 21.3945 62.6866 21.3814C62.6511 21.3682 62.6122 21.3677 62.5763 21.3798C62.5404 21.392 62.5098 21.4161 62.4896 21.4481V21.4481C62.482 21.4583 62.4756 21.4694 62.4706 21.4811C62.4377 21.5567 62.3782 21.6177 62.3033 21.6524C62.2284 21.6871 62.1434 21.6931 62.0644 21.6692C62.0523 21.6654 62.0398 21.6629 62.0272 21.6618V21.6618C61.9897 21.6563 61.9515 21.6638 61.9189 21.6831C61.8863 21.7023 61.8613 21.7322 61.8482 21.7677C61.835 21.8032 61.8345 21.8422 61.8466 21.878C61.8588 21.9139 61.8829 21.9445 61.9149 21.9647C61.9252 21.9722 61.9362 21.9786 61.948 21.9837C62.0237 22.0167 62.0846 22.0764 62.1192 22.1514C62.1537 22.2264 62.1595 22.3115 62.1354 22.3905C62.1315 22.4025 62.129 22.415 62.1279 22.4276C62.1224 22.4651 62.1299 22.5033 62.1492 22.5359C62.1685 22.5684 62.1984 22.5934 62.2339 22.6066C62.2694 22.6197 62.3084 22.6203 62.3443 22.6081C62.3801 22.596 62.4108 22.5719 62.431 22.5398V22.5398C62.4385 22.5296 62.4449 22.5185 62.45 22.5068C62.483 22.4312 62.5427 22.3703 62.6178 22.3357C62.6929 22.3012 62.778 22.2954 62.857 22.3195C62.8691 22.3234 62.8815 22.3259 62.8942 22.3269V22.3269C62.9316 22.3325 62.9699 22.325 63.0025 22.3057C63.0351 22.2864 63.06 22.2565 63.0732 22.221C63.0864 22.1855 63.0869 22.1466 63.0748 22.1107C63.0626 22.0749 63.0385 22.0443 63.0065 22.0241V22.0241C62.996 22.0162 62.9846 22.0095 62.9726 22.0043V22.0043Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M60.7039 37.6295C60.6282 37.5965 60.5672 37.5368 60.5327 37.4618C60.4981 37.3868 60.4924 37.3017 60.5165 37.2227C60.5204 37.2106 60.5229 37.1982 60.5239 37.1856C60.5295 37.1481 60.522 37.1099 60.5027 37.0773C60.4834 37.0447 60.4535 37.0198 60.4179 37.0066C60.3824 36.9935 60.3435 36.9929 60.3076 37.0051C60.2717 37.0172 60.2411 37.0413 60.2209 37.0733V37.0733C60.2133 37.0836 60.2069 37.0946 60.2019 37.1063C60.1688 37.182 60.1091 37.2429 60.0341 37.2775C59.959 37.312 59.8739 37.3178 59.7948 37.2937C59.7828 37.2898 59.7703 37.2873 59.7577 37.2862V37.2862C59.7202 37.2807 59.682 37.2882 59.6494 37.3075C59.6168 37.3268 59.5918 37.3567 59.5786 37.3922C59.5655 37.4276 59.5649 37.4666 59.5771 37.5024C59.5892 37.5383 59.6134 37.5689 59.6454 37.5891C59.6556 37.5967 59.6667 37.603 59.6784 37.6081C59.7541 37.6411 59.8151 37.7008 59.8496 37.7758C59.8842 37.8508 59.89 37.9359 59.8658 38.0149C59.862 38.027 59.8595 38.0394 59.8584 38.052V38.052C59.8529 38.0895 59.8604 38.1277 59.8797 38.1603C59.899 38.1929 59.9289 38.2178 59.9644 38.231C59.9999 38.2441 60.0389 38.2447 60.0747 38.2325C60.1106 38.2204 60.1412 38.1963 60.1614 38.1643V38.1643C60.169 38.154 60.1754 38.143 60.1804 38.1313C60.2135 38.0556 60.2732 37.9947 60.3483 37.9601C60.4233 37.9256 60.5085 37.9198 60.5875 37.9439C60.5995 37.9478 60.612 37.9503 60.6246 37.9514C60.6621 37.9569 60.7004 37.9494 60.7329 37.9301C60.7655 37.9108 60.7905 37.8809 60.8037 37.8454C60.8168 37.8099 60.8174 37.771 60.8052 37.7352C60.7931 37.6993 60.769 37.6687 60.7369 37.6485V37.6485C60.7267 37.6409 60.7156 37.6346 60.7039 37.6295Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M62.3934 6.49097C62.3176 6.45794 62.2567 6.39823 62.2221 6.32322C62.1876 6.24821 62.1818 6.16313 62.2059 6.08414C62.2098 6.07209 62.2123 6.05963 62.2134 6.04701C62.2189 6.00956 62.2114 5.97134 62.1921 5.93876C62.1728 5.90619 62.1429 5.88123 62.1074 5.86807C62.0719 5.85492 62.0329 5.85437 61.997 5.86651C61.9612 5.87866 61.9306 5.90276 61.9103 5.93478V5.93478C61.9028 5.94501 61.8964 5.95609 61.8914 5.96779C61.8583 6.04347 61.7986 6.10437 61.7235 6.13891C61.6485 6.17344 61.5633 6.17921 61.4843 6.15511C61.4722 6.15122 61.4598 6.14873 61.4471 6.14768V6.14768C61.4097 6.14214 61.3714 6.14964 61.3388 6.16892C61.3062 6.1882 61.2813 6.2181 61.2681 6.2536C61.2549 6.2891 61.2544 6.32804 61.2665 6.36389C61.2787 6.39975 61.3028 6.43034 61.3348 6.45054V6.45054C61.3451 6.45812 61.3562 6.46449 61.3679 6.46952C61.4436 6.50256 61.5045 6.56226 61.5391 6.63727C61.5736 6.71228 61.5794 6.79737 61.5553 6.87635C61.5514 6.8884 61.5489 6.90086 61.5479 6.91349V6.91349C61.5423 6.95093 61.5498 6.98915 61.5691 7.02173C61.5884 7.05431 61.6183 7.07927 61.6538 7.09242C61.6894 7.10558 61.7283 7.10613 61.7642 7.09398C61.8001 7.08184 61.8307 7.05773 61.8509 7.02572C61.8585 7.01548 61.8648 7.00441 61.8699 6.99271C61.9029 6.91702 61.9627 6.85612 62.0377 6.82159C62.1128 6.78705 62.1979 6.78128 62.2769 6.80538C62.289 6.80927 62.3015 6.81177 62.3141 6.81281C62.3516 6.81836 62.3898 6.81086 62.4224 6.79157C62.455 6.77229 62.48 6.74239 62.4931 6.7069C62.5063 6.6714 62.5068 6.63246 62.4947 6.5966C62.4825 6.56074 62.4584 6.53015 62.4264 6.50995V6.50995C62.4162 6.50238 62.4051 6.49601 62.3934 6.49097V6.49097Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M67.6961 47.0961C67.6204 47.063 67.5594 47.0033 67.5249 46.9283C67.4903 46.8533 67.4845 46.7682 67.5087 46.6892C67.5126 46.6772 67.515 46.6647 67.5161 46.6521C67.5216 46.6147 67.5141 46.5764 67.4948 46.5439C67.4755 46.5113 67.4456 46.4863 67.4101 46.4732C67.3746 46.46 67.3356 46.4595 67.2998 46.4716C67.2639 46.4838 67.2333 46.5079 67.2131 46.5399V46.5399C67.2055 46.5501 67.1991 46.5612 67.1941 46.5729C67.161 46.6486 67.1013 46.7095 67.0262 46.744C66.9512 46.7785 66.8661 46.7843 66.787 46.7602C66.775 46.7563 66.7625 46.7538 66.7499 46.7528V46.7528C66.7124 46.7472 66.6742 46.7547 66.6416 46.774C66.609 46.7933 66.584 46.8232 66.5708 46.8587C66.5577 46.8942 66.5571 46.9331 66.5693 46.969C66.5814 47.0048 66.6055 47.0354 66.6376 47.0556C66.6478 47.0632 66.6589 47.0696 66.6706 47.0746C66.7463 47.1077 66.8073 47.1674 66.8418 47.2424C66.8764 47.3174 66.8821 47.4025 66.858 47.4814C66.8541 47.4935 66.8516 47.506 66.8506 47.5186V47.5186C66.8451 47.556 66.8526 47.5942 66.8718 47.6268C66.8911 47.6594 66.9211 47.6844 66.9566 47.6975C66.9921 47.7107 67.0311 47.7112 67.0669 47.6991C67.1028 47.6869 67.1334 47.6628 67.1536 47.6308V47.6308C67.1612 47.6206 67.1676 47.6095 67.1726 47.5978C67.2057 47.5221 67.2654 47.4612 67.3405 47.4267C67.4155 47.3921 67.5006 47.3864 67.5797 47.4105C67.5917 47.4144 67.6042 47.4169 67.6168 47.4179C67.6543 47.4234 67.6925 47.416 67.7251 47.3967C67.7577 47.3774 67.7827 47.3475 67.7959 47.312C67.809 47.2765 67.8096 47.2375 67.7974 47.2017C67.7853 47.1658 67.7611 47.1352 67.7291 47.1151V47.1151C67.7189 47.1075 67.7078 47.1011 67.6961 47.0961Z"
        fill="#4D8AF0"
      />
      <path
        opacity="0.5"
        d="M1.13388 22.7674C1.43758 22.7674 1.68378 22.5213 1.68378 22.2178C1.68378 21.9143 1.43758 21.6682 1.13388 21.6682C0.830182 21.6682 0.583984 21.9143 0.583984 22.2178C0.583984 22.5213 0.830182 22.7674 1.13388 22.7674Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M62.4952 13.5505C62.7989 13.5505 63.0451 13.3044 63.0451 13.0009C63.0451 12.6974 62.7989 12.4513 62.4952 12.4513C62.1915 12.4513 61.9453 12.6974 61.9453 13.0009C61.9453 13.3044 62.1915 13.5505 62.4952 13.5505Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M37.4845 34.2392C37.8265 34.2392 38.1037 33.9621 38.1037 33.6203C38.1037 33.2784 37.8265 33.0013 37.4845 33.0013C37.1425 33.0013 36.8652 33.2784 36.8652 33.6203C36.8652 33.9621 37.1425 34.2392 37.4845 34.2392Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M37.4845 34.2392C37.8265 34.2392 38.1037 33.9621 38.1037 33.6203C38.1037 33.2784 37.8265 33.0013 37.4845 33.0013C37.1425 33.0013 36.8652 33.2784 36.8652 33.6203C36.8652 33.9621 37.1425 34.2392 37.4845 34.2392Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M69.3253 30.0754C69.629 30.0754 69.8752 29.8293 69.8752 29.5258C69.8752 29.2223 69.629 28.9762 69.3253 28.9762C69.0216 28.9762 68.7754 29.2223 68.7754 29.5258C68.7754 29.8293 69.0216 30.0754 69.3253 30.0754Z"
        fill="#F55F44"
      />
      <path
        opacity="0.5"
        d="M24.8732 5.46476C25.2152 5.46476 25.4924 5.18766 25.4924 4.84584C25.4924 4.50403 25.2152 4.22693 24.8732 4.22693C24.5312 4.22693 24.2539 4.50403 24.2539 4.84584C24.2539 5.18766 24.5312 5.46476 24.8732 5.46476Z"
        fill="#47E6B1"
      />
      <path
        opacity="0.5"
        d="M60.1554 52.7742C60.4591 52.7742 60.7053 52.5282 60.7053 52.2246C60.7053 51.9211 60.4591 51.675 60.1554 51.675C59.8517 51.675 59.6055 51.9211 59.6055 52.2246C59.6055 52.5282 59.8517 52.7742 60.1554 52.7742Z"
        fill="#F55F44"
      />
      <path
        d="M25.9069 32.4305C25.5816 33.486 26.0721 34.7337 27.0241 35.2891C27.4237 35.5218 27.8836 35.639 28.2708 35.8915C29.1122 36.4395 29.4441 37.4883 29.7174 38.4538C30.0312 39.5637 30.3458 40.7372 30.0584 41.8537C29.8751 42.5659 29.4582 43.1955 29.2212 43.892C29.023 44.4754 28.954 45.0948 29.0189 45.7075C29.0536 46.0326 29.1345 46.3677 29.3574 46.6103C29.6794 46.9569 30.198 47.0089 30.6636 47.0922C31.6482 47.2783 32.5745 47.695 33.3668 48.308C34.159 48.9211 34.7946 49.7132 35.2213 50.6192"
        stroke="url(#icon-balloon-present-box-100px0_linear)"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <path
        d="M26.0066 32.4305C25.6812 33.486 26.1717 34.7337 27.1237 35.2891C27.5233 35.5218 27.9832 35.639 28.3705 35.8915C29.2118 36.4395 29.5437 37.4883 29.817 38.4538C30.1308 39.5637 30.4454 40.7372 30.158 41.8537C29.9747 42.5659 29.5578 43.1955 29.3208 43.892C29.1226 44.4754 29.0536 45.0948 29.1185 45.7075C29.1532 46.0326 29.2341 46.3677 29.457 46.6103C29.779 46.9569 30.2976 47.0089 30.7633 47.0922C31.7478 47.2783 32.6741 47.695 33.4664 48.308C34.2586 48.9211 34.8942 49.7132 35.321 50.6192"
        stroke="#535461"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <path
        d="M38.3221 24.5413C37.5196 25.6594 36.6865 26.8618 36.6179 28.2366C36.5131 30.3483 38.2032 32.0755 38.9579 34.0511C39.285 34.9213 39.433 35.8486 39.3931 36.7773C39.3533 37.7061 39.1263 38.6172 38.7259 39.4563C38.3576 40.2171 37.8325 40.973 37.9002 41.8156C37.939 42.3297 38.1966 42.7976 38.4039 43.2704C38.9125 44.4555 39.1345 45.7437 39.0517 47.0305C38.9689 48.3174 38.5838 49.5666 37.9275 50.6768"
        stroke="url(#icon-balloon-present-box-100px1_linear)"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <path
        d="M38.4206 24.5413C37.6189 25.6636 36.7858 26.8626 36.7156 28.2366C36.6107 30.3483 38.3009 32.0755 39.0556 34.0511C39.3826 34.9213 39.5307 35.8486 39.4908 36.7773C39.4509 37.7061 39.224 38.6172 38.8235 39.4563C38.4553 40.2171 37.9302 40.973 37.9979 41.8156C38.0367 42.3297 38.2943 42.7976 38.5015 43.2704C39.0102 44.4555 39.2321 45.7437 39.1493 47.0305C39.0666 48.3174 38.6814 49.5666 38.0251 50.6768"
        stroke="#535461"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <path
        d="M49.5813 34.5989L49.9693 37.7603C50.0205 38.1803 50.0643 38.6383 49.8389 38.9981C49.625 39.3373 49.2237 39.499 48.9116 39.7499C47.887 40.5751 47.9803 42.1521 48.3337 43.418C48.6871 44.6839 49.1957 46.0438 48.7044 47.2619C48.5013 47.7644 48.143 48.1878 47.8787 48.6598C47.4254 49.4664 47.2458 50.3981 47.3668 51.3153"
        stroke="url(#icon-balloon-present-box-100px2_linear)"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <path
        d="M49.6789 34.5989L50.067 37.7603C50.1182 38.1803 50.1619 38.6383 49.9365 38.9981C49.7227 39.3373 49.3214 39.499 49.0093 39.7499C47.9846 40.5751 48.078 42.1521 48.4313 43.418C48.7847 44.6839 49.2933 46.0438 48.8021 47.2619C48.5989 47.7644 48.2406 48.1878 47.9764 48.6598C47.5231 49.4664 47.3435 50.3981 47.4645 51.3153"
        stroke="#535461"
        stroke-width="0.774194"
        stroke-miterlimit="10"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M59.6438 21.6055C59.6431 20.1264 59.2923 18.6686 58.6201 17.351C57.9478 16.0334 56.9732 14.8935 55.7758 14.0244C54.5784 13.1554 53.1923 12.5817 51.7307 12.3505C50.2691 12.1193 48.7735 12.2369 47.3661 12.6939C47.4435 12.1673 47.4835 11.6359 47.4858 11.1037C47.4895 8.6747 46.5491 6.33919 44.863 4.58979C43.177 2.84039 40.877 1.81387 38.4482 1.72674C36.0194 1.63961 33.6517 2.49868 31.8444 4.12276C30.0372 5.74684 28.9317 8.00895 28.7612 10.432C27.3534 9.97403 25.8572 9.85562 24.3949 10.0865C22.9325 10.3173 21.5456 10.8908 20.3476 11.7601C19.1496 12.6294 18.1745 13.7698 17.502 15.0879C16.8295 16.4061 16.4788 17.8647 16.4785 19.3444C16.4785 24.0481 19.9463 30.7324 24.4586 31.9166L25.1613 32.3176L24.7798 33.6239H27.0389L26.5484 32.316L27.2477 31.9166C30.737 31.0014 33.598 26.8002 34.7184 22.7707C35.3318 23.1787 36.0071 23.4852 36.7182 23.6784L37.4208 24.0795L37.0452 25.3825H39.3042L38.8137 24.0745L39.5131 23.6751C40.0314 23.5357 40.5305 23.3331 40.9993 23.0719C41.6029 27.5924 44.8139 33.1115 48.877 34.1768L49.5797 34.5779L49.1982 35.8842H51.4573L50.9652 34.5762L51.6645 34.1768C56.1801 32.9926 59.6438 26.3059 59.6438 21.6055Z"
          fill="url(#icon-balloon-present-box-100px3_linear)"
        />
      </g>
      <path
        d="M27.3993 33.1399H25.2129L25.596 31.8295H26.9072L27.3993 33.1399Z"
        fill="#F55F44"
      />
      <path
        d="M35.3213 19.3227C35.3213 24.3302 31.2599 31.6655 26.2505 31.6655C21.2412 31.6655 17.1797 24.3293 17.1797 19.3227C17.1797 16.9182 18.1354 14.6122 19.8366 12.9119C21.5378 11.2117 23.8451 10.2565 26.2509 10.2565C28.6568 10.2565 30.9641 11.2117 32.6653 12.9119C34.3664 14.6122 35.3222 16.9182 35.3222 19.3227H35.3213Z"
        fill="#F55F44"
      />
      <path
        d="M26.9066 31.8843H25.5955L24.8301 31.4478H27.672L26.9066 31.8843Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M22.9715 12.2766C22.9715 12.2766 19.1462 14.352 18.5996 18.5029Z"
        fill="white"
      />
      <path
        d="M39.2606 25.1704H37.0742L37.4573 23.86H38.7685L39.2606 25.1704Z"
        fill="#4D8AF0"
      />
      <path
        d="M47.1827 11.3524C47.1827 16.3598 43.1212 23.6952 38.1118 23.6952C33.1025 23.6952 29.041 16.359 29.041 11.3524C29.041 8.94788 29.9967 6.64184 31.6979 4.94158C33.3991 3.24133 35.7064 2.28613 38.1122 2.28613C40.5181 2.28613 42.8254 3.24133 44.5266 4.94158C46.2278 6.64184 47.1835 8.94788 47.1835 11.3524H47.1827Z"
        fill="#F70C00"
      />
      <path
        d="M38.768 23.914H37.4568L36.6914 23.4767H39.5334L38.768 23.914Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M34.8348 4.30713C34.8348 4.30713 31.0095 6.38255 30.4629 10.5334Z"
        fill="white"
      />
      <path
        d="M51.0243 35.3326H48.8379L49.221 34.0214H50.5322L51.0243 35.3326Z"
        fill="#3AD29F"
      />
      <path
        d="M58.9472 21.5145C58.9472 26.5219 54.8857 33.8573 49.8763 33.8573C44.867 33.8573 40.8047 26.5219 40.8047 21.5145C40.8047 19.11 41.7604 16.8039 43.4616 15.1037C45.1628 13.4034 47.4701 12.4482 49.8759 12.4482C52.2818 12.4482 54.5891 13.4034 56.2903 15.1037C57.9914 16.8039 58.9472 19.11 58.9472 21.5145V21.5145Z"
        fill="#3AD29F"
      />
      <path
        d="M50.5316 34.0761H49.2205L48.4551 33.6395H51.297L50.5316 34.0761Z"
        fill="#535461"
      />
      <path
        opacity="0.1"
        d="M46.5965 14.4684C46.5965 14.4684 42.7712 16.5438 42.2246 20.6947Z"
        fill="white"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M43.2233 36.8776C42.6974 36.3503 41.9303 36.1407 41.0634 36.2867C40.2526 36.4237 39.4409 36.8644 38.7788 37.5246C38.5869 37.7174 38.4257 37.9383 38.3007 38.1798C38.1789 37.9302 38.0191 37.701 37.8268 37.5006V37.5006C37.1761 36.8281 36.3719 36.375 35.5603 36.2265C34.6966 36.0614 33.9263 36.262 33.3904 36.7802C32.8546 37.2985 32.6349 38.0618 32.7687 38.9299C32.8942 39.7419 33.3219 40.5597 33.9734 41.2306C35.3423 42.6426 38.0745 42.0913 38.1901 42.0666L38.2239 42.0591L38.3288 42.0831C38.4444 42.1095 41.1666 42.7077 42.5595 41.3197C43.22 40.6596 43.6634 39.85 43.8038 39.0397C43.9565 38.1724 43.7493 37.4057 43.2233 36.8776ZM37.731 41.2512C37.0704 41.3404 35.4249 41.4608 34.6083 40.6183C34.0832 40.0761 33.7397 39.4292 33.6414 38.7946C33.5523 38.2169 33.6811 37.7218 34.0064 37.4099C34.1333 37.2881 34.2852 37.1952 34.4514 37.1375C34.7587 37.0382 35.0868 37.0217 35.4026 37.0897C36.0334 37.2077 36.6708 37.5708 37.1959 38.1129C38.0125 38.9497 37.8408 40.5935 37.731 41.2504V41.2512ZM42.9418 38.8903C42.8328 39.5224 42.4786 40.1644 41.9436 40.6967C41.1121 41.5219 39.4665 41.3758 38.8101 41.2743C38.7119 40.6142 38.5682 38.9728 39.3997 38.1443C39.9347 37.612 40.5779 37.2597 41.2104 37.154C41.5273 37.0916 41.8551 37.1138 42.1607 37.2184C42.3262 37.279 42.4766 37.3747 42.6016 37.499C42.9203 37.8183 43.0409 38.3118 42.9418 38.8895V38.8903Z"
          fill="url(#icon-balloon-present-box-100px4_linear)"
        />
      </g>
      <path
        d="M38.4567 41.8866L38.1966 41.9411C38.086 41.9642 35.4719 42.4915 34.1615 41.1406C33.539 40.4986 33.1295 39.7163 33.0056 38.9389C32.8768 38.1079 33.0882 37.3776 33.6001 36.8817C34.112 36.3857 34.8493 36.1976 35.6758 36.3519C36.4495 36.4963 37.219 36.9295 37.8416 37.5724C39.1511 38.9232 38.5417 41.5186 38.5153 41.6283L38.4567 41.8866ZM34.6148 37.2249C34.4557 37.2801 34.3103 37.3691 34.1888 37.4857C33.8783 37.7869 33.7545 38.2573 33.8395 38.811C33.9337 39.4176 34.2623 40.0373 34.7651 40.5564C35.547 41.3626 37.1216 41.2471 37.7532 41.1621C37.8581 40.5341 38.0232 38.9645 37.2413 38.1583C36.7385 37.64 36.1291 37.2918 35.5247 37.1796C35.2227 37.1145 34.9089 37.1301 34.6148 37.2249V37.2249Z"
        fill="#F70C00"
      />
      <path
        d="M38.0706 41.8978L38.0128 41.6386C37.988 41.5281 37.4233 38.9228 38.7559 37.5951C39.39 36.9638 40.1662 36.5437 40.9423 36.4125C41.768 36.2722 42.5053 36.4728 43.0065 36.9778C43.5077 37.4828 43.7083 38.2156 43.5655 39.0408C43.4317 39.8157 43.009 40.5906 42.3748 41.2219C41.0422 42.5497 38.4372 41.977 38.329 41.9522L38.0706 41.8978ZM41.9926 37.2988C41.7005 37.1988 41.3872 37.1774 41.0843 37.2369C40.4783 37.3392 39.8631 37.6768 39.3504 38.1859C38.5545 38.979 38.6899 40.5502 38.7865 41.1806C39.4165 41.2764 40.9894 41.4191 41.7845 40.6269C42.2964 40.1169 42.6349 39.503 42.7398 38.894C42.8347 38.3419 42.7191 37.869 42.4137 37.5629C42.2939 37.4457 42.1503 37.3556 41.9926 37.2988V37.2988Z"
        fill="#F70C00"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M50.8196 41.2045H25.4707V46.2738H26.7876V60.9453H49.5027V46.2738H50.8196V41.2045Z"
          fill="url(#icon-balloon-present-box-100px5_linear)"
        />
      </g>
      <path
        d="M49.2166 42.7363H27.0762V60.6956H49.2166V42.7363Z"
        fill="#EEEEEE"
      />
      <path
        d="M40.2299 45.9435H36.0586V60.6951H40.2299V45.9435Z"
        fill="#F70C00"
      />
      <path
        opacity="0.1"
        d="M49.2166 41.7745H27.0762V46.2646H49.2166V41.7745Z"
        fill="black"
      />
      <path
        d="M50.5003 41.4532H25.793V45.9433H50.5003V41.4532Z"
        fill="#EEEEEE"
      />
      <path
        d="M40.2299 41.4532H36.0586V45.9433H40.2299V41.4532Z"
        fill="#F70C00"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-balloon-present-box-100px0_linear"
        x1="25.7236"
        y1="41.5269"
        x2="35.2956"
        y2="41.5269"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="icon-balloon-present-box-100px1_linear"
        x1="1752.23"
        y1="13895.2"
        x2="1851.83"
        y2="13895.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="icon-balloon-present-box-100px2_linear"
        x1="2045.54"
        y1="9990.25"
        x2="2138.13"
        y2="9990.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="icon-balloon-present-box-100px3_linear"
        x1="27397.1"
        y1="17420"
        x2="27397.1"
        y2="3282.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="icon-balloon-present-box-100px4_linear"
        x1="7118.88"
        y1="3594.13"
        x2="7118.88"
        y2="3148.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="icon-balloon-present-box-100px5_linear"
        x1="11557.2"
        y1="14394.4"
        x2="11557.2"
        y2="9671.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <clipPath id="clip-icon-balloon-present-box-100px0">
        <rect
          x="0.583984"
          y="0.944946"
          width="69.2903"
          height="60"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
